import { ltrim } from "@taager/reinforcements";
import { environment } from "environment";

export function mediaUrl(path: string): string {
  return environment.IMAGES_BUCKET_URL + ltrim(path, "/");
}
